export default "__VITE_ASSET__DqNpParH__"